import { FC } from 'react';
import { Flex, Tabs, TabsProps } from '@chakra-ui/react';

type PlanTabsProps = { currentTab: number } & Pick<
  TabsProps,
  'onChange' | 'onKeyDown' | 'children'
>;
const PlanTabs: FC<PlanTabsProps> = ({
  children,
  currentTab,
  onChange,
  onKeyDown,
}) => (
  <Tabs
    alignItems="center"
    as={Flex}
    defaultIndex={currentTab}
    flexDirection="column"
    index={currentTab}
    marginBottom="10px"
    onChange={onChange}
    onKeyDown={onKeyDown}
    outline="none"
    width={{ base: '100%', md: 'initial' }}
  >
    {children}
  </Tabs>
);

export default PlanTabs;
